import moment from 'moment'

export const dayNames = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat']
export const getDayName = date => {
  const dayIndex = date.getDay()
  return dayNames[dayIndex]
}
export const daysInReverse = daysBack => {
  const dayAbbreviations = []
  const today = new Date()

  for (let i = 0; i < daysBack; i++) {
    const day = new Date(today)
    day.setDate(today.getDate() - i)
    dayAbbreviations.push(day.toLocaleString('en-US', {weekday: 'short'}))
  }

  return dayAbbreviations
}

// Format the date portion (YYYY-MM-dd) using toLocaleString
export const formatDate = timestamp => {
  return timestamp
    ? new Date(timestamp).toLocaleDateString(undefined, {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit'
      })
    : ''
}

export const formatDateTime = timestamp => {
  return timestamp ? moment(timestamp).local().format('M/D/YYYY HH:mm') : ''
}

export const formatTimestamp = timestamp => {
  return timestamp ? moment(timestamp).local().format('M/D/YYYY HH:mm:ss') : ''
}

export const formatPeriod = period => {
  if (!period || !period.start || !period.end) {
    return ''
  }

  // Subtract 24 hours from period.end
  const endDate = new Date(period.end)
  endDate.setHours(endDate.getHours() - 24)

  // Format the begin and end dates
  const beginDateFormatted = formatDate(period.start)
  const endDateFormatted = formatDate(endDate)

  // If begin and end dates are the same, return only begin date
  const displayText =
    beginDateFormatted === endDateFormatted ? beginDateFormatted : `${beginDateFormatted} to ${endDateFormatted}`
  return displayText
}

export const calculateEndDate = (startDate, minutesToAdd) => {
  if (!(startDate instanceof Date)) {
    throw new Error('startDate must be a Date object')
  }

  if (isNaN(startDate.getTime())) {
    throw new Error('startDate is an invalid Date')
  }

  const msToAdd = minutesToAdd * 60 * 1000 - 1000

  return new Date(startDate.getTime() + msToAdd)
}
